import React from 'react';


const FileUpload = ({
    handleChange,
    className
}) => {

    return (
        <input
            type="file"
            className={className}
            id="image"
            accept="image/*"
            onChange={(e) => handleChange(e)}
        />
    );
};

export default FileUpload;